import React from 'react';
import { Info } from 'lucide-react';
import { Link } from 'react-router-dom';

const ItemContent = ({ number, incresedNumber, title }) => (
  <>
    <h3 className="docpro_fs_28 docpro_fw_500 docpro_mb_0">
      {number}
      {incresedNumber && (
        <span className="docpro_green_color docpro_fs_14">
          {incresedNumber}
        </span>
      )}
    </h3>
    <p className="docpro_mb_0 docpro_fw_500">{title}</p>
  </>
);

export default function ChartCard({ children, headingData, selectBox, tooltip=false }) {
  return (
    <div className="docpro_card docpro_card_2" style={{ height: '100%' }}>
      <div className={`docpro_card_heading ${tooltip && "docpro_dashboard_payment"}`}>
        <ul className="docpro_card_heading_list">
          {headingData?.map((item, index) => (
            <li className="docpro_card_heading_list_item" key={index}>
              {!item.href && (
                <ItemContent
                  number={item.number}
                  incresedNumber={item.incresedNumber}
                  title={item.title}
                />
              )}
              {item.href && (
                <Link to={item.href}>
                  <ItemContent
                    number={item.number}
                    incresedNumber={item.incresedNumber}
                    title={item.title}
                  />
                </Link>
              )}

              {/* <h3 className="docpro_fs_28 docpro_fw_500 docpro_mb_0">
                {item.number}{' '}
                {item.incresedNumber && (
                  <span className="docpro_green_color docpro_fs_14">
                    {item.incresedNumber}
                  </span>
                )}
              </h3>
              <p className="docpro_mb_0 docpro_fw_500">{item.title}</p> */}
            </li>
          ))}
        </ul>

        {tooltip && (
          <button className="docpro_icon_btn last_btn_tip overview" style={{ width: 'auto', height: 'auto', borderRadius: '50%' }} >
            <Info width={16} height={16} />
            <div className="docpro_tip">
              <span>{headingData[1]?.title}</span> <br />
              <span>{headingData[1]?.number}</span>
            </div>
          </button>
        )}
        {/* {selectBox && (
          <div className="docpro_card_dropdown">
            <select name="">
              <option value="1">All doctors</option>
              <option value="1">Dr. Mary Mia</option>
              <option value="1">Dr. Coar Gil</option>
              <option value="1">Dr. Jhon Smith</option>
            </select>
          </div>
        )} */}
      </div>
      {children}
    </div>
  );
}
